import React from 'react';
import {
  Box,
  Heading,
  Text,
  VStack,
  Container,
  Divider,
} from '@chakra-ui/react';
import Footer from '../components/layout/footer';

const PrivacyAgreement = () => {
  return (
    <Container maxW="container.md" py={10} flexDirection={"column"}
    >
      <VStack spacing={6} align="start">
        <Heading as="h1" size="xl">
          Privacy Agreement
        </Heading>

        <Text fontSize="md" color="gray.600">
          Your privacy is important to us. This Privacy Agreement explains how we collect, use, and protect your personal information when you use our CRM platform.
        </Text>

        <Box>
          <Heading as="h2" size="lg" mb={3}>
            1. Information We Collect
          </Heading>
          <Text mb={4}>
            We collect personal information you provide during signup and use of the platform, such as your name, email address, phone number, and usage data.
          </Text>

          <Heading as="h2" size="lg" mb={3}>
            2. How We Use Your Information
          </Heading>
          <Text mb={4}>
            Your data is used to provide and improve our services, communicate with you, process payments, and personalize your experience.
          </Text>

          <Heading as="h2" size="lg" mb={3}>
            3. Data Sharing and Disclosure
          </Heading>
          <Text mb={4}>
            We do not sell your personal information. We may share data with trusted third-party service providers who assist us in operating the platform, subject to confidentiality agreements.
          </Text>

          <Heading as="h2" size="lg" mb={3}>
            4. Data Security
          </Heading>
          <Text mb={4}>
            We implement industry-standard security measures to protect your personal information against unauthorized access, alteration, or destruction.
          </Text>

          <Heading as="h2" size="lg" mb={3}>
            5. Data Retention
          </Heading>
          <Text mb={4}>
            We retain your personal information only as long as necessary to provide services and comply with legal obligations.
          </Text>

          <Heading as="h2" size="lg" mb={3}>
            6. Your Rights
          </Heading>
          <Text mb={4}>
            You have the right to access, update, or delete your personal data. You may also opt out of marketing communications at any time.
          </Text>

          <Heading as="h2" size="lg" mb={3}>
            7. Cookies and Tracking
          </Heading>
          <Text mb={4}>
            We use cookies and similar technologies to enhance your experience. You can control cookie preferences via your browser settings.
          </Text>

          <Heading as="h2" size="lg" mb={3}>
            8. Changes to This Privacy Agreement
          </Heading>
          <Text mb={4}>
            We may update this agreement occasionally. Continued use of the platform constitutes acceptance of any changes.
          </Text>

          <Heading as="h2" size="lg" mb={3}>
            9. Contact Us
          </Heading>
          <Text mb={4}>
            For any questions about your privacy or this agreement, please contact us at privacy@saleradius.com
          </Text>

          <Divider my={6} />

          <Text>
            By using our platform, you acknowledge that you have read and agreed to this Privacy Agreement.
          </Text>
        </Box>
      </VStack>
      <Footer />
    </Container>
  );
};

export default PrivacyAgreement;
